import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Button,
  Container,
  Stack,
  Typography,
  Modal,
  Box,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  CircularProgress,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import moment from "moment";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ImageViewer from "react-simple-image-viewer";
import "../App.css";
import { createBid, addNotification, getAllRequests } from "../apis";
import { io } from "socket.io-client";
import { ShareSocial } from "react-share-social";
import { useParams } from "react-router-dom";
import Navbar from "../components/Navbar";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  maxHeight: 700,
  overflowY: "scroll",
};

const Request = () => {
  let { id } = useParams();
  const socket = useRef();
  const [open, setOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [offerDetails, setOfferDetails] = useState("");
  const [offerType, setOfferType] = useState("project");
  const [amount, setAmount] = useState("");
  const [stageData, setStageData] = useState([
    { stageDetail: "", price: "", dueDate: "" },
  ]);
  const [userData, setUserData] = useState();
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [viewOnly, setViewOnly] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentRequest, setCurrentRequest] = useState({});

  const date = moment(currentRequest.fromDate).utc().format("MMMM Do, YYYY");
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleShareClose = () => setShareOpen(false);

  const handleofferType = (e) => setOfferType(e.target.value);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAllRequests();
      const filteredrequest = response.data.requests.filter(
        (item) => item._id == id
      );
      setCurrentRequest(filteredrequest[0]);
      setLoading(false);
    };
    fetchData();
    if (localStorage.getItem("user-type") == "service provider") {
      setViewOnly(false);
    } else {
      setViewOnly(true);
    }
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const data = await getUserById(currentRequest.userid);
  //     setUserData(data);
  //   };
  //   fetchData();
  // }, [currentRequest]);

  // useEffect(() => {
  //   console.log(userData);
  // }, [userData]);

  const handleChange = (i, e) => {
    let newStageData = [...stageData];
    newStageData[i][e.target.name] = e.target.value;
    setStageData(newStageData);
  };

  const handleChangeDate = (i, newDate) => {
    let newStageData = [...stageData];
    newStageData[i]["dueDate"] = newDate;
    setStageData(newStageData);
  };

  const addStageHandler = () => {
    let checkEmpty = false;
    stageData.map((item) => {
      checkEmpty = Object.values(item).some((x) => x == "");
    });
    if (!checkEmpty) {
      setStageData([...stageData, { stageDetail: "", price: "", dueDate: "" }]);
    }
  };

  let removeFormFields = (i) => {
    let newStageData = [...stageData];
    if (newStageData.length > 1) {
      newStageData.splice(i, 1);
      setStageData(newStageData);
    }
  };

  const makeOfferHandler = async () => {
    let user = JSON.parse(localStorage.getItem("user-info"));
    if (offerType == "project") {
      createBid({
        userId: currentRequest.userid,
        serviceProviderId: user._id,
        requestId: currentRequest._id,
        offerDetails: offerDetails,
        offerType: offerType,
        price: amount,
        StageData: stageData,
        bidStatus: "pending",
        bidCreatorName: currentRequest.creatorName,
        serviceProviderName: user.fullName,
        serviceProviderCountry: user.country,
      });
      handleClose();
    } else {
      let totalAmount = 0;
      stageData.map((item) => {
        totalAmount = totalAmount + item.price;
      });
      createBid({
        userId: currentRequest.userid,
        serviceProviderId: user._id,
        requestId: currentRequest._id,
        offerDetails: offerDetails,
        offerType: offerType,
        price: totalAmount,
        StageData: stageData,
        bidStatus: "pending",
        bidCreatorName: currentRequest.creatorName,
        serviceProviderName: user.fullName,
        serviceProviderCountry: user.country,
      });
      handleClose();
    }
    socket.current = io("https://ammanat-chat-socket.herokuapp.com");
    socket.current.emit("send-notification", {
      receiverId: currentRequest.userid,
      to: currentRequest.userid,
      message: "New bid received. You have a new bid",
      read: false,
    });
    await addNotification({
      to: currentRequest.userid,
      message: "New bid received. You have a new bid",
      read: false,
    });
  };

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const shareURL = `https://ammanat.netlify.app/request/${currentRequest._id}`;

  if (loading) {
    return (
      <Box
        sx={{ display: "flex" }}
        justifyContent="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <CircularProgress disableShrink />
      </Box>
    );
  }

  return (
    <>
      <Navbar />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Make an Offer
            </Typography>
            <div
              className="crossIconContainer"
              style={{ cursor: "pointer" }}
              onClick={handleClose}
            >
              <span className="crossIcon">X</span>
            </div>
          </Stack>
          <Stack spacing={4}>
            <Stack className="mt-13">
              <Typography>Offer Details</Typography>
              <TextField
                required
                id="outlined-basic"
                variant="outlined"
                className="w-100"
                size="small"
                placeholder="Enter details of your offer here"
                value={offerDetails}
                onChange={(e) => setOfferDetails(e.target.value)}
              />
            </Stack>
            <Stack direction={{ xs: "column", sm: "row" }}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={offerType}
                onChange={handleofferType}
              >
                <FormControlLabel
                  value="project"
                  control={<Radio />}
                  label="Project base"
                />
                <FormControlLabel
                  value="staged"
                  control={<Radio />}
                  label="Staged Payments"
                />
              </RadioGroup>
            </Stack>
            {offerType == "project" ? (
              <Stack>
                <Typography>Enter your price</Typography>
                <TextField
                  required
                  id="outlined-basic"
                  variant="outlined"
                  className="w-100"
                  size="small"
                  placeholder="Enter amount here"
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
              </Stack>
            ) : (
              <Stack>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  {stageData.map((item, index) => (
                    <>
                      <Stack className="mb-13">
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Typography>Enter stage details</Typography>
                          <Typography
                            style={{
                              cursor: "pointer",
                              color: "rgba(250, 131, 25, 1)",
                            }}
                            onClick={() => removeFormFields(index)}
                          >
                            Delete
                          </Typography>
                        </Stack>
                        <TextField
                          required
                          id="outlined-basic"
                          variant="outlined"
                          className="w-100"
                          size="small"
                          name="stageDetail"
                          placeholder="Enter the details of stage"
                          value={item.stageDetail}
                          onChange={(e) => handleChange(index, e)}
                        />
                      </Stack>
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={3}
                        className="mb-13"
                      >
                        <Stack className="w-100">
                          <Typography>Enter price</Typography>
                          <TextField
                            required
                            id="outlined-basic"
                            variant="outlined"
                            className="w-100"
                            size="small"
                            name="price"
                            placeholder="Enter stage price"
                            value={item.price}
                            onChange={(e) => handleChange(index, e)}
                          />
                        </Stack>
                        <Stack className="w-100">
                          <Typography>Due Date</Typography>
                          <DesktopDatePicker
                            value={item.dueDate}
                            className="w-100"
                            minDate={new Date("2017-01-01")}
                            onChange={(newValue) => {
                              handleChangeDate(index, newValue);
                            }}
                            renderInput={(params) => (
                              <TextField {...params} size="small" />
                            )}
                            disablePast
                          />
                          {/* <TextField
                          required
                          id="outlined-basic"
                          variant="outlined"
                          className="w-100"
                          size="small"
                          name="dueDate"
                          placeholder="Enter due date"
                          value={item.dueDate}
                          onChange={(e) => handleChange(index, e)}
                        /> */}
                        </Stack>
                      </Stack>
                    </>
                  ))}
                </LocalizationProvider>
                <Button
                  variant="outlined"
                  className="default-color w-43"
                  style={{ border: "1px solid rgba(245, 245, 245, 1)" }}
                  onClick={addStageHandler}
                >
                  + Add New Stage
                </Button>
              </Stack>
            )}
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Button
                style={{ textTransform: "capitalize" }}
                variant="outlined"
                className="default-border default-color"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                style={{ textTransform: "capitalize" }}
                variant="contained"
                className="primary-button"
                onClick={makeOfferHandler}
              >
                Submit
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={shareOpen}
        onClose={handleShareClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography style={{ fontWeight: "bold" }}>Share</Typography>
          <ShareSocial
            url={shareURL}
            socialTypes={[
              "facebook",
              "twitter",
              "reddit",
              "linkedin",
              "whatsapp",
            ]}
          />
        </Box>
      </Modal>

      <Container style={{ background: "#FAFBFE", height: "100vh" }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack>
            <h2>Request Details</h2>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={4}>
            {/* <ShareSocial
              url="url_to_share.com"
              socialTypes={[
                "facebook",
                "twitter",
                "reddit",
                "linkedin",
                "whatsapp",
              ]}
            /> */}
            <ShareOutlinedIcon
              onClick={() => setShareOpen(true)}
              style={{ cursor: "pointer" }}
            />
            <FavoriteBorderOutlinedIcon />
          </Stack>
        </Stack>
        <Grid container>
          <Grid item sm={2}>
            <AccountCircleIcon
              style={{ height: "80px", width: "80px", color: "#EEEBEF" }}
            />
          </Grid>
          <Grid item sm={10}>
            <Stack direction="row" justifyContent="space-between">
              <Stack>
                <h4>{currentRequest.title}</h4>
                <Typography
                  className="mb-10"
                  style={{ textTransform: "capitalize" }}
                >
                  {currentRequest.creatorName}
                </Typography>
              </Stack>

              <div
                style={{ background: "white", padding: "20px", width: "200px" }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  style={{ marginBottom: "20px" }}
                >
                  <Typography style={{ color: "#7A7A80" }}>Budget</Typography>
                  <Typography style={{ fontWeight: "bold" }}>
                    £{currentRequest.budget}
                  </Typography>
                </Stack>
                <Stack spacing={2} alignItems="center">
                  {viewOnly ? (
                    <></>
                  ) : (
                    <>
                      <Button
                        variant="contained"
                        className="primary-button"
                        style={{
                          textTransform: "capitalize",
                          width: "168px",
                        }}
                        onClick={handleOpen}
                      >
                        Make Offer
                      </Button>
                      <Button
                        variant="outlined"
                        className="report-button"
                        style={{ textTransform: "capitalize", width: "168px" }}
                      >
                        Report
                      </Button>
                    </>
                  )}
                </Stack>
              </div>
            </Stack>

            <Stack>
              <h4>Address</h4>
              <Typography variant="body1" style={{ color: "#7A7A80" }}>
                {currentRequest.address}
              </Typography>
            </Stack>
            {currentRequest.urgent == true ? (
              <>
                <h4>Due Date</h4>
                <span
                  style={{
                    background: "rgba(255, 0, 32, 0.1)",
                    border: "1px solid #EB4335",
                    borderRadius: "100px",
                    padding: "4px 8px",
                    color: "rgba(235, 67, 53, 1)",
                  }}
                >
                  Urgent
                </span>
              </>
            ) : (
              <>
                <h4>Due Date</h4>
                <Typography variant="body1" style={{ color: "#7A7A80" }}>
                  {date}
                </Typography>
              </>
            )}
            <Stack>
              <h4>Details</h4>
              <Typography variant="body1" style={{ color: "#7A7A80" }}>
                {currentRequest.details}
              </Typography>
            </Stack>
            {currentRequest.images.length ? (
              <Stack>
                <h4>Images and Videos</h4>
                {currentRequest.images.map((item, index) => (
                  <img
                    src={item}
                    style={{
                      height: "120px",
                      width: "120px",
                      cursor: "pointer",
                      objectFit: "contain",
                    }}
                    onClick={() => openImageViewer(index)}
                  />
                ))}
                {isViewerOpen && (
                  <ImageViewer
                    src={currentRequest.images}
                    currentIndex={currentImage}
                    onClose={closeImageViewer}
                    disableScroll={true}
                    backgroundStyle={{
                      backgroundColor: "rgba(0,0,0,0.9)",
                    }}
                    closeOnClickOutside={true}
                  />
                )}
              </Stack>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Request;
